import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.space[3]};
  min-height: 50vh;
  padding: ${({ theme }) => theme.space[4]};
`;
